import React from "react";

const TONES = {
  neutral: "bg-gradient-to-b from-neutral-700 to-neutral-900 border-neutral-600 text-neutral-200 hover:from-neutral-600 hover:to-neutral-800",
  primary: "bg-gradient-to-b from-blue-500 to-blue-700 border-blue-400 text-white hover:from-blue-400 hover:to-blue-600",
  go: "bg-gradient-to-b from-emerald-500 to-emerald-700 border-emerald-400 text-white hover:from-emerald-400 hover:to-emerald-600",
  stop: "bg-gradient-to-b from-red-500 to-red-700 border-red-400 text-white hover:from-red-400 hover:to-red-600",
  queue: "bg-gradient-to-b from-purple-500 to-purple-700 border-purple-400 text-white hover:from-purple-400 hover:to-purple-600",
  warn: "bg-gradient-to-b from-amber-400 to-orange-600 border-amber-300 text-white hover:from-amber-300 hover:to-orange-500",
  ghost: "bg-neutral-900 border-neutral-700 text-neutral-300 hover:bg-neutral-800 hover:text-white",
};

// Hardware-style round buttons: dark metal body with a tinted LED ring per tone.
const ROUND_LED = {
  neutral: "#a3a3a3",
  primary: "#60a5fa",
  go: "#34d399",
  stop: "#f87171",
  queue: "#c084fc",
  warn: "#fbbf24",
  ghost: "#a3a3a3",
};

export default function HardwareButton({
  onClick,
  disabled,
  tone = "neutral",
  active,
  children,
  title,
  type = "button",
  size = "md",
  round = false,
  className = "",
}) {
  let sizeClass;
  if (round) {
    sizeClass = size === "sm"
      ? "w-9 h-9 text-[11px]"
      : size === "lg"
      ? "w-14 h-14 text-sm"
      : "w-12 h-12 text-xs";
  } else {
    sizeClass = size === "sm"
      ? "px-3 h-8 text-[11px]"
      : size === "lg"
      ? "px-6 h-12 text-sm"
      : "px-4 h-10 text-xs";
  }

  const shapeClass = round
    ? "rounded-full inline-flex items-center justify-center"
    : "rounded-md";

  const base = `${sizeClass} ${shapeClass} font-bold uppercase tracking-wider transition-all border active:translate-y-[1px]`;

  if (round) {
    const led = ROUND_LED[tone] || ROUND_LED.neutral;
    const lit = !disabled && tone !== "neutral" && tone !== "ghost";
    const body = "bg-gradient-to-b from-neutral-800 to-neutral-950 hover:from-neutral-700 hover:to-neutral-900";
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        title={title}
        className={`${base} ${body} disabled:from-neutral-900 disabled:to-neutral-950 disabled:cursor-not-allowed ${className}`}
        style={{
          borderColor: disabled ? "#27272a" : lit ? `${led}99` : "#3f3f46",
          color: disabled ? "#525252" : lit ? led : "#a3a3a3",
          boxShadow: lit
            ? `0 0 10px ${led}55, inset 0 0 0 1px rgba(255,255,255,0.04), inset 0 -3px 6px rgba(0,0,0,0.55), 0 1px 2px rgba(0,0,0,0.5)`
            : "inset 0 0 0 1px rgba(255,255,255,0.04), inset 0 -3px 6px rgba(0,0,0,0.55), 0 1px 2px rgba(0,0,0,0.5)",
        }}
      >
        {children}
      </button>
    );
  }

  const activeTone = tone === "neutral" && active ? TONES.go : TONES[tone];

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`${base} shadow-md ${activeTone} disabled:bg-neutral-800 disabled:border-neutral-700 disabled:text-neutral-600 disabled:shadow-none disabled:cursor-not-allowed disabled:from-neutral-800 disabled:to-neutral-900 ${className}`}
    >
      {children}
    </button>
  );
}
